module.exports = __webpack_public_path__ + "img/logo-menu.6a38a8c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-menu.png
// module id = RnLi
// module chunks = 1